function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { Tabs, message, Skeleton, Button, Typography, Select, Space, Alert, Drawer, Form, Modal, notification, DatePicker, Input } from 'antd';
import { Table } from 'react-bootstrap';
import { PencilSquare, HourglassSplit, CheckCircleFill, EyeFill } from "react-bootstrap-icons";
import Common from "../components/includes/Common";
import Moment from "react-moment";
import SaveMedicalQuestions from "../components/forms/SaveMedicalQuestions";
import DisplayFile from "../components/DisplayFile";
import MedForm from "../components/forms/MedForm";
import MedFormPe from "../components/forms/MedFormPe";
import MedFormVa from "../components/forms/MedFormVa";
import MedFormJour from "../components/forms/MedFormJour";
import MedFormFhVa from "../components/forms/MedFormFhVa";
import MedFormFhPe from "../components/forms/MedFormFhPe";
import MedFormPeEn from "../components/forms/MedFormPeEn";
import MedFormVaEn from "../components/forms/MedFormVaEn";
import MedFormEn from "../components/forms/MedFormEn";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Text = Typography.Text,
  Link = Typography.Link;
var Consultations = function Consultations() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isDataLoading = _useState2[0],
    setIsDataLoading = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    compList = _useState4[0],
    setCompList = _useState4[1];
  var _useState5 = useState([{
      value: 0,
      label: "TOUTES"
    }]),
    _useState6 = _slicedToArray(_useState5, 2),
    compOptions = _useState6[0],
    setCompOptions = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    companyId = _useState8[0],
    setCompanyId = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    company = _useState0[0],
    setCompany = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    customers = _useState10[0],
    setCustomers = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrentCustomer = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    dataChanged = _useState14[0],
    setDataChanged = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    showEditData = _useState16[0],
    setShowEditData = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    showDisplayData = _useState18[0],
    setShowDisplayData = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    showNewForm = _useState20[0],
    setShowNewForm = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showEditForm = _useState22[0],
    setShowEditForm = _useState22[1];
  var _useState23 = useState(20),
    _useState24 = _slicedToArray(_useState23, 2),
    limit = _useState24[0],
    setLimit = _useState24[1];
  var _useState25 = useState(0),
    _useState26 = _slicedToArray(_useState25, 2),
    offset = _useState26[0],
    setOffset = _useState26[1];
  var _useState27 = useState("0"),
    _useState28 = _slicedToArray(_useState27, 2),
    keyword = _useState28[0],
    setKeyword = _useState28[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var handleCompanyChange = function handleCompanyChange(v) {
    if (compList.filter(function (c) {
      return c.id == v;
    }).length > 0) {
      setCompany(compList.filter(function (c) {
        return c.id == v;
      })[0]);
      setCompanyId(compList.filter(function (c) {
        return c.id == v;
      })[0].id);
      localStorage.setItem("defaultCompany", compList.filter(function (c) {
        return c.id == v;
      })[0].id);
    } else {
      setCompany(null);
      setCompanyId(0);
      localStorage.setItem("defaultCompany", 0);
    }
  };
  var handleKewordChange = function handleKewordChange(v) {
    setKeyword(v.target.value);
  };
  var handleMore = function handleMore() {
    setLimit(function (prev) {
      return prev + 20;
    });
  };
  var items = [{
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(HourglassSplit, {
        size: 24
      })
    }),
    key: 1,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "MOTIF"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.medecine_questions_id == null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.reason
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx(Space, {
                  direction: "horizontal",
                  children: /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowNewForm(true);
                    },
                    children: [/*#__PURE__*/_jsx(PencilSquare, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " TRAITER"
                    })]
                  })
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }, {
    label: /*#__PURE__*/_jsx("b", {
      children: /*#__PURE__*/_jsx(CheckCircleFill, {
        size: 24
      })
    }),
    key: 2,
    children: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(Table, {
        striped: true,
        bordered: true,
        hover: true,
        responsive: true,
        children: [/*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsxs("tr", {
            children: [/*#__PURE__*/_jsx("th", {
              children: "Date"
            }), /*#__PURE__*/_jsx("th", {
              children: "CODE"
            }), /*#__PURE__*/_jsx("th", {
              children: "TYPE"
            }), /*#__PURE__*/_jsx("th", {
              children: "NOM"
            }), /*#__PURE__*/_jsx("th", {
              children: "POSTE"
            }), /*#__PURE__*/_jsx("th", {
              children: "CONTACT"
            }), /*#__PURE__*/_jsx("th", {
              children: "SOCIETE"
            }), /*#__PURE__*/_jsx("th", {
              children: "MOTIF"
            }), /*#__PURE__*/_jsx("th", {
              children: "NATIONALITE"
            }), /*#__PURE__*/_jsx("th", {
              children: "ACTION"
            })]
          })
        }), /*#__PURE__*/_jsx("tbody", {
          children: customers.filter(function (c) {
            return c.medecine_questions_id != null;
          }).map(function (c) {
            return /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsx("b", {
                  children: /*#__PURE__*/_jsx(Moment, {
                    date: c.created_at,
                    format: "DD/MM/YYYY"
                  })
                })
              }), /*#__PURE__*/_jsx("td", {
                children: c.candidate_code
              }), /*#__PURE__*/_jsx("td", {
                children: c.category != "0" && c.category
              }), /*#__PURE__*/_jsx("td", {
                children: c.name
              }), /*#__PURE__*/_jsx("td", {
                children: c.job
              }), /*#__PURE__*/_jsx("td", {
                children: c.mobile_first
              }), /*#__PURE__*/_jsx("td", {
                children: c.company.label
              }), /*#__PURE__*/_jsx("td", {
                children: c.reason
              }), /*#__PURE__*/_jsx("td", {
                children: c.nationality
              }), /*#__PURE__*/_jsx("td", {
                children: /*#__PURE__*/_jsxs(Space, {
                  direction: "horizontal",
                  children: [/*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowNewForm(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " MODIFIER"
                    })]
                  }), /*#__PURE__*/_jsxs(Button, {
                    type: "link",
                    onClick: function onClick() {
                      setCurrentCustomer(c);
                      setShowDisplayData(true);
                    },
                    children: [/*#__PURE__*/_jsx(EyeFill, {
                      size: 22
                    }), " ", /*#__PURE__*/_jsx("b", {
                      children: " VOIR"
                    })]
                  })]
                })
              })]
            }, c.id);
          })
        })]
      }), isDataLoading == true && /*#__PURE__*/_jsx(Skeleton, {
        active: true
      })]
    })
  }];
  var loadData = function loadData(cid) {
    setIsDataLoading(true);
    if (cid == null) return;
    axios.post("".concat(Common.baseApiUrl, "getmedicalqueue"), {
      company_id: cid,
      user_id: Common.currentUser.id,
      limit: limit,
      offset: offset,
      keyword: keyword
    }).then(function (response) {
      setCustomers([]);
      setCustomers(response.data.customers);
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  };
  useEffect(function () {
    setIsDataLoading(true);
    axios.get(Common.baseApiUrl + 'getcompanylist').then(function (response) {
      if (response.data.status == 200) {
        setCompOptions([{
          value: 0,
          label: "TOUTES"
        }]);
        response.data.companyList.forEach(function (c) {
          setCompOptions(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: c.id,
              label: c.label
            }]);
          });
        });
        setCompList(response.data.companyList);
        //setCompanyId(response.data.companyList[0].id);     
        setCompanyId(0);
        //setCompany(response.data.companyList[0]);
        setCompany(null);
        //loadData(response.data.companyList[0].id);      
        if (response.data.companyList.length > 0) {
          if (localStorage.getItem("defaultCompany") != null && localStorage.getItem("defaultCompany") != 'undefined') {
            form.setFieldsValue({
              comp: parseInt(localStorage.getItem("defaultCompany"))
            });
          } else {
            form.setFieldsValue({
              comp: response.data.companyList[0].id
            });
            localStorage.setItem("defaultCompany", response.data.companyList[0].id);
          }
        }
        loadData(localStorage.getItem("defaultCompany"));
      } else {
        message.error({
          content: 'Une erreur est survenue',
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: 'Une erreur est survenue',
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, []);
  useEffect(function () {
    loadData(companyId);
  }, [companyId, dataChanged, keyword, limit, offset]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        children: [/*#__PURE__*/_jsx(Text, {
          mark: true,
          children: /*#__PURE__*/_jsx("b", {
            children: "#QUESTIONNAIRE_MEDICAL"
          })
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
      })
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        lg: 12,
        md: 12,
        children: [/*#__PURE__*/_jsx(Form, {
          form: form,
          children: /*#__PURE__*/_jsxs(Space, {
            direction: "horizontal",
            children: [/*#__PURE__*/_jsx(Form.Item, {
              name: "comp",
              children: /*#__PURE__*/_jsx(Select, {
                options: compOptions,
                onChange: handleCompanyChange,
                style: {
                  width: "200px"
                }
              })
            }), /*#__PURE__*/_jsx(Form.Item, {
              children: /*#__PURE__*/_jsx(Input, {
                onChange: handleKewordChange,
                placeholder: "Code dossier"
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Tabs, {
          items: items,
          animated: true,
          tabPlacement: "start",
          defaultActiveKey: 1
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("div", {
          style: {
            textAlign: "center"
          },
          children: /*#__PURE__*/_jsx(Button, {
            loading: isDataLoading,
            type: "default",
            onClick: handleMore,
            children: /*#__PURE__*/_jsx("b", {
              children: "VOIR PLUS"
            })
          })
        })]
      })
    }), currentCustomer && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Drawer, {
        open: showEditData,
        title: /*#__PURE__*/_jsx("b", {
          children: "ENTREZ LES DONNEES DU QUESTIONNAIRE"
        }),
        width: "85%",
        centered: true,
        onClose: function onClose() {
          setShowEditData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(MedForm, {
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowEditData(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), /*#__PURE__*/_jsx(Drawer, {
        open: showNewForm,
        title: currentCustomer.nationality.toLowerCase().indexOf("guin") > -1 && currentCustomer.nationality.split(" ").length == 1 ? /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["Formulaire de questionnaires - ", currentCustomer.category != "0" && currentCustomer.category.toUpperCase()]
          })
        }) : /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsxs("b", {
            children: ["Formulaire de questionnaires - EN - ", currentCustomer.category != "0" && currentCustomer.category.toUpperCase()]
          })
        }),
        width: "85%",
        centered: true,
        onClose: function onClose() {
          setShowNewForm(false);
        },
        destroyOnClose: true,
        children: currentCustomer.nationality.toLowerCase().indexOf("guin") > -1 && currentCustomer.nationality.split(" ").length == 1 ? /*#__PURE__*/_jsx(MedForm, {
          formType: currentCustomer.category,
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowNewForm(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        }) : /*#__PURE__*/_jsx(MedFormEn, {
          formType: currentCustomer.category,
          candidat: currentCustomer,
          handler: function handler() {
            setDataChanged(true);
            setShowNewForm(false);
            notification.success({
              message: "Ok!",
              description: "Les donnés ont été sauvegardées"
            });
          }
        })
      }), currentCustomer.medecine_questions && /*#__PURE__*/_jsx(Drawer, {
        open: showDisplayData,
        title: /*#__PURE__*/_jsx("b", {
          children: "FORMULAIRE DE QUESTIONNAIRE MEDICAL"
        }),
        width: "85%",
        onClose: function onClose() {
          setShowDisplayData(false);
        },
        destroyOnClose: true,
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [currentCustomer.medecine_questions.form_type == 0 && /*#__PURE__*/_jsx(DisplayFile, {
            file_url: currentCustomer.medecine_questions.file
          }), currentCustomer.nationality.toLowerCase().indexOf("guin") > -1 && currentCustomer.nationality.split(" ").length == 1 ? /*#__PURE__*/_jsx(MedForm, {
            readOnly: 1,
            formType: currentCustomer.category,
            candidat: currentCustomer,
            handler: function handler() {
              setDataChanged(true);
              setShowNewForm(false);
              notification.success({
                message: "Ok!",
                description: "Les donnés ont été sauvegardées"
              });
            }
          }) : /*#__PURE__*/_jsx(MedFormEn, {
            readOnly: 1,
            formType: currentCustomer.category,
            candidat: currentCustomer,
            handler: function handler() {
              setDataChanged(true);
              setShowNewForm(false);
              notification.success({
                message: "Ok!",
                description: "Les donnés ont été sauvegardées"
              });
            }
          })]
        })
      })]
    })]
  });
};
export default Consultations;